var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 800",
    style: {
      enableBackground: "new 0 0 1122 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 1122,
    height: 800
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#E8E8E8"
    },
    d: "M1032.147,639H182.717c-28.872,0-52.495,9.962-52.495,22.137l0,0 c0,8.431,11.331,15.797,27.884,19.533h-57.612C71.623,680.67,48,690.632,48,702.807l0,0c0,12.175,23.623,22.137,52.495,22.137 h5.241c-7.822,3.868-12.568,8.873-12.568,14.324v8.855c0,12.175,23.623,22.137,52.495,22.137h835.844 c28.872,0,52.495-9.962,52.495-22.137v-8.855c0-12.175-23.623-22.137-52.495-22.137l2.217,0.492c4.657,0,12.219-1.549,17.292-4.664 c8.895-5.461,9.29-13.774,4.941-20.655c-2.819-4.461-7.336-7.998-18.527-9.328l44.719,0.299c28.872,0,52.495-9.962,52.495-22.137 l0,0C1084.642,648.962,1061.019,639,1032.147,639z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M402.68,144.584c-54.794,13.425-83.467-11.424-87.341-15.102c0,0-0.087-0.376-0.229-0.221 c-0.15-0.147-0.217,0.233-0.217,0.233c-3.669,3.882-30.953,30.248-86.394,19.811c0,0-5.774,99.39,27.451,138.971 c35.487,42.277,64.804,54.555,64.946,54.439c0.148,0.108,29.012-13.498,61.902-57.877 C413.567,243.32,402.68,144.584,402.68,144.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M394.892,155.002c-49.727,11.977-75.734-10.132-79.248-13.405c0,0-0.079-0.334-0.208-0.196 c-0.136-0.131-0.197,0.207-0.197,0.207c-3.331,3.458-28.102,26.944-78.405,17.678c0,0-5.286,88.488,24.845,123.712 c32.182,37.622,58.816,50.902,58.945,50.798c0.135,0.096,26.296-14.393,56.161-53.918 C404.725,242.9,394.892,155.002,394.892,155.002z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.06
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.456,150.311c0,0,0.064-0.354,0.206-0.217c0.135-0.145,0.218,0.206,0.218,0.206 c3.608,3.361,29.871,25.686,79.992,14.728c-0.488-8.991-1.116-14.609-1.116-14.609 c-49.727,11.977-75.734-10.132-79.248-13.405c0,0-0.079-0.334-0.208-0.196c-0.137-0.131-0.197,0.207-0.197,0.207 c-3.331,3.458-28.102,26.944-78.405,17.678c0,0-0.337,5.643-0.355,14.643C287.009,177.588,312.034,153.863,315.456,150.311z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E8F4"
    },
    d: "M380.73,179.935c-37.566,9.204-61.749-8.615-64.405-11.136c0,0-0.06-0.258-0.157-0.151 c-0.103-0.101-0.149,0.16-0.149,0.16c-2.515,2.662-25.458,21.709-63.467,14.554c0,0,0.277,67.169,23.056,94.306 c24.33,28.984,44.429,37.403,44.527,37.323c0.102,0.074,19.891-9.254,42.439-39.68 C383.669,246.845,380.73,179.935,380.73,179.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "324.279,345.947 318.287,340.292 318.191,333.027 316.641,332.266 315.626,334.135  313.821,328.128 309.582,325.308 303.25,327.715 299.618,333.698 302.674,339.733 309.412,344.127 317.279,352.223  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305399"
    },
    points: "323.702,339.131 312.922,351.897 341.836,395.815 352.597,399.287 398.434,362.734  386.175,337.706 351.989,366.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "469.154,683.949 470.755,691.292 458.071,701.748 449.328,695.962 454.87,687.063  467.554,676.607  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCBEC0"
    },
    points: "424.795,458.181 438.949,490.819 440.284,582.647 469.386,681.42 455.854,687.421  396.466,572.731 389.707,536.405 387.021,459.899  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCBEC0"
    },
    points: "356.268,465.495 355.156,561.731 373.291,685.812 387.235,685.812 396.042,571.321  415.124,456.829  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "387.155,684.153 387.155,691.692 372.075,699.232 364.536,691.692 372.075,684.153  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M383.729,335.184l37.041-1.372c0,0,22.159,19.443,33.611,69.966 c11.661,51.445-2.154,125.506-2.154,125.506s-99.376-13.245-115.67-15.291l24.859-101.575L383.729,335.184z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M397.003,338.968c4.326-0.423,8.651-0.846,12.977-1.269c0.047-3.466-0.184-6.935-0.689-10.364 c3.607-1.263,7.775-3.158,8.408-6.926c0.199-1.187-0.004-2.4-0.207-3.587c-0.841-4.904-1.681-9.808-2.522-14.712 c-0.291-1.696-0.6-3.442-1.52-4.896c-1.615-2.552-4.754-3.671-7.728-4.192c-7.591-1.328-15.866,0.305-21.759,5.27 c-1.568,1.321-2.987,2.91-3.681,4.84c-1.069,2.976-0.277,6.261,0.522,9.321c0.738,2.824,1.475,5.648,2.212,8.472 c0.848,3.248,2.074,6.941,5.201,8.163c1.66,0.649,3.622,0.462,5.124,1.421C395.99,332.199,395.627,336.142,397.003,338.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M354.743,289.955c-0.084-3.362,0.388-6.764,1.06-9.829c1.154-5.268,7.369-7.636,12.749-8.009 c11.619-0.806,22.833-6.074,34.18-2.008c6.486,2.324,15.197,2.882,21.067,6.159c2.451,1.368,4.405,3.504,5.928,5.863 c5.275,8.171,5.289,19.427,0.035,27.611c-1.179,1.836-2.589,3.514-4.07,5.116c-3.066,3.316-6.734,7.412-10.947,8.637 c-0.095-3.768,3.352-15.643,0.463-18.734c-4.585-4.906-14.969-3.211-20.667-2.012c-6.215,1.308-11.759,5.7-17.92,6.632 c-4.433,0.671-10.087-1.511-13.854-3.807C356.866,301.974,354.895,296.029,354.743,289.955z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F7"
    },
    d: "M393.945,339.764l-38.94,155.761l-3.192,20.428l48.516,6.384c0,0-1.915-74.588-1.277-84.533 c0.638-9.945,7.833-31.455,8.937-54.63c0.638-13.406,4.896-37.484,1.915-45.324L393.945,339.764z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "359.064,422.913 350.384,425.656 343.32,421.843 341.752,422.93 343.011,424.915  336.242,423.429 331.241,426.004 330.159,433.411 333.983,440.133 341.451,440.427 349.315,436.285 361.359,433.043  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M351.683,423.514c13.48-3.161,26.96-6.322,40.44-9.483c3.629-0.851,7.392-1.034,11.021-1.912 c5.306-1.284,6.759-1.732,7.504-6.791c2.161-14.665-0.585-29.88,1.63-44.325c5.324-0.529,10.464-1.791,15.898-1.719 c8.875,0.117,8.105,6.222,8.604,13.024c0.592,8.067,0.945,16.16,1,24.248c0.046,6.703,2.258,35.775-7.588,37.902 c-7.056,1.547-78.168,5.333-78.138,6.792C352.043,440.662,351.683,423.514,351.683,423.514z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "249.457,354.345 254.446,349.643 254.529,343.599 255.819,342.966 256.662,344.522  258.168,339.525 261.696,337.181 266.963,339.186 269.982,344.166 267.436,349.185 261.828,352.838 255.278,359.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#587BC9"
    },
    points: "251.035,346.969 223.103,380.074 186.635,344.747 180.963,386.979 225.357,408.989  260.295,356.613  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "129.174,678.385 128.569,684.355 139.416,691.8 145.746,686.567 140.625,679.859  129.779,672.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "129.445,495.851 127.608,513.983 143.873,576.279 128.77,676.384 139.887,680.215  169.203,582.482 173.856,554.05 173.686,493.861  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "214.952,516.06 191.568,683.8 180.938,683.8 179.025,576.279 159.679,500.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "180.999,682.474 180.999,688.499 192.494,694.525 198.241,688.499 192.494,682.474  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M188.837,343.866c-0.842-1.376-1.967-2.548-3.509-3.419c-10.56-5.96-28.064-0.711-39.523-0.711 c-3.386,35.655-12.749,69.636-18.795,104.642c-6.422,37.18-13.653,74.22-21.686,111.085c-0.455,2.088,31.891,1.034,34.942,1.086 c31.119,0.525,71.853,0.418,101.879-8.991c-19.163-51.445-26.159-106.798-41.249-159.581c-2.649-9.267-5.795-18.394-8.181-27.736 C191.331,354.826,191.544,348.291,188.837,343.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M174.718,291.255c7.877,2.155,14.078,9.444,14.942,17.565c4.305-4.01,6.502-10.167,5.71-15.997 c-0.793-5.83-4.555-11.177-9.774-13.892c-4.883,2.592-8.67,7.177-10.291,12.463L174.718,291.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M190.741,301.81c-4.07-21.488-30.917-17.775-38.619-0.374c-4.38,9.896,0.209,23.904,8.97,30.789 c0.188,1.902,0.435,7.151,1.889,8.423c1.575,1.377,6.537,0.065,8.481-0.385c0.539-0.125,1.103-0.28,1.493-0.671 c0.489-0.49,0.572-1.803,0.581-3.258c1.427-0.097,2.889-0.375,4.377-0.864c6.244-2.05,10.767-7.831,12.637-14.132 C192.421,315.036,191.964,308.267,190.741,301.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M151.543,409.001c-0.857-1.462-1.421-3.13-1.695-4.702c-0.472-2.709-0.122-5.576,1.037-8.072 c0.501-1.079,1.705-1.699,2.859-1.244c1.058,0.417,1.748,1.775,1.244,2.859c-1.163,2.503-1.229,5.312-0.163,7.829 c0.533-0.301,1.095-0.553,1.674-0.75c2.123-0.724,5.306-1.524,6.894,0.591c1.788,2.38,0.173,5.24-2.168,6.397 c-1.848,0.913-4.09,1.303-6.007,0.573c-0.003,2.708,0.773,4.091,3.35,4.848c1.566,0.46,5.459,0.859,6.699-0.62 c0.803-0.958,0.738-3.863,1.027-5.146c0.8-3.559,1.987-7.029,3.524-10.337c3.12-6.716,7.662-12.703,13.056-17.756 c12.182-11.411,28.289-18.054,44.56-20.988c0.898-0.162,1.798-0.313,2.701-0.453c11.205-1.738,22.169-1.4,32.377,0.879 c2.254-3.616,5.169-6.789,8.686-9.206c7.849-5.392,18.728-6.528,27.063-1.921c-6.536,7.641-11.9,18.594-12.759,20.39 c9.821,6.06,18.125,14.49,24.149,25.104c0.126,0.221,0.242,0.431,0.354,0.637l12.191,1.941c0,0,4.558,23.909,1.853,31.128 c0,0-9.477,3.9-15.229,5.459c-4.3,9.774-11.594,18.67-21.08,25.82c-0.628,0.473-1.267,0.938-1.914,1.396l2.96,19.084 c0,0-14.626,7.368-22.459,6.033l-6.541-12.74c-3.731,1.073-7.595,1.932-11.573,2.549c-4.704,0.73-9.351,1.148-13.899,1.262 l-2.399,14.266c-7.061,3.645-23.232,1.053-23.232,1.053l-2.958-19.074c-21.008-6.59-36.485-21.672-40.009-44.392 c-0.3-1.936-0.499-3.846-0.601-5.729c-3.411-0.082-6.77-0.95-9.497-3.142c-2.1-1.688-3.471-3.868-4.167-6.465 C150.823,414.023,150.41,411.251,151.543,409.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBAD95"
    },
    d: "M257.436,365.366l-1.486,7.246c0,0-22.447-2.718-44.291,6.869l-5.613-4.105 C206.046,375.376,225.164,357.156,257.436,365.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.03
    },
    d: "M171.232,432.533c10.21,14.808,26.721,23.77,43.796,28.287 c12.642,3.344,26.269,4.89,39.496,3.586c19.147-1.888,36.255-10.375,52.108-20.598c0.698-0.45,1.38-0.917,2.055-1.39 c-4.279,6.758-10.044,12.921-16.982,18.151c-10.749,8.102-24.314,13.963-39.527,16.323 c-40.461,6.276-76.658-10.417-82.449-46.591C170.208,431.059,170.723,431.795,171.232,432.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.03
    },
    d: "M314.148,397.098c0,0,9.724,23.264-1.443,38.048l5.778-1.85 C318.483,433.296,324.1,411.083,314.148,397.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M245.759,296.044c-12.355,1.993-20.754,13.624-18.761,25.979 c1.993,12.355,13.624,20.754,25.979,18.761s20.754-13.624,18.761-25.979C269.745,302.451,258.113,294.051,245.759,296.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#232020"
    },
    d: "M245.434,294.029c-13.467,2.173-22.624,14.851-20.451,28.319 c2.173,13.467,14.852,22.624,28.319,20.451c13.467-2.173,22.624-14.852,20.451-28.319 C271.58,301.013,258.901,291.857,245.434,294.029z M252.641,338.703c-11.205,1.808-21.754-5.81-23.562-17.016 c-1.808-11.205,5.811-21.754,17.016-23.562s21.754,5.81,23.562,17.016C271.464,326.346,263.846,336.896,252.641,338.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M245.03,291.528c-14.849,2.395-24.944,16.375-22.549,31.224 c2.396,14.849,16.375,24.944,31.224,22.549c14.849-2.395,24.944-16.375,22.549-31.224 C273.858,299.228,259.879,289.133,245.03,291.528z M252.976,340.784c-12.355,1.993-23.986-6.407-25.979-18.761 c-1.993-12.355,6.407-23.986,18.761-25.979c12.355-1.993,23.986,6.406,25.979,18.761 C273.731,327.16,265.331,338.791,252.976,340.784z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E8F4"
    },
    d: "M243.142,326.307c-0.304-0.148-0.416-0.54-0.536-0.892c-0.306-0.896,0.156-1.684,1.052-1.935 c1.343-0.376,2.905,0.445,4.239,0.843c1.096,0.327,2.26,0.395,3.492,0.204c1.319-0.205,2.327-0.69,3.024-1.456 c0.697-0.766,0.964-1.672,0.802-2.717c-0.164-1.06-0.602-1.765-1.312-2.114c-0.711-0.349-1.844-0.402-3.399-0.161 l-1.027,0.159c-2.539,0.394-4.557,0.164-6.053-0.69c-1.496-0.854-2.401-2.289-2.714-4.306 c-0.306-1.972,0.107-3.603,1.239-4.896c1.131-1.292,2.873-2.121,5.226-2.485c0.958-0.149,1.96-0.139,3.006,0.027 c2.174,0.347,5.862,1.49,5.455,3.661c-0.464,2.476-4.613-0.363-5.973-0.713c-0.796-0.205-1.699-0.23-2.706-0.073 c-1.17,0.181-2.065,0.638-2.684,1.368c-0.62,0.731-0.855,1.575-0.707,2.53c0.146,0.941,0.617,1.556,1.414,1.846 c0.797,0.289,2.413,0.276,4.85-0.041c2.6-0.327,4.576-0.079,5.927,0.744c1.351,0.823,2.19,2.287,2.517,4.393 c0.313,2.017-0.097,3.732-1.228,5.147c-1.132,1.415-2.817,2.296-5.058,2.643c-0.709,0.11-1.512,0.154-2.407,0.133 C247.913,327.487,245.238,327.327,243.142,326.307z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E8F4"
    },
    d: "M252.076,332.822l-0.028,0.004c-0.773,0.12-1.512-0.508-1.651-1.402l-4.282-27.606 c-0.139-0.894,0.376-1.717,1.149-1.836l0.028-0.005c0.773-0.12,1.512,0.508,1.651,1.402l4.282,27.606 C253.364,331.879,252.85,332.702,252.076,332.822z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "162.875,420.306 170.016,422.642 175.877,419.554 177.163,420.464 176.107,422.091  181.706,420.921 185.811,423.088 186.642,429.209 183.431,434.725 177.266,434.906 170.81,431.422 160.897,428.647  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M144.017,412.596c-3.01-2.035-5.079-4.926-5.347-9.186c-0.247-3.925,0.673-7.815,1.35-11.689 c2.15-12.298,1.866-25.017-0.831-37.208c-2.684-12.13-16.834,3.122-18.594,8.594c-1.95,6.065-1.401,12.669-1.877,18.94 c-0.638,8.42-0.941,16.865-0.906,25.309c0.022,5.342-1.294,17.961,4.331,21.018c1.521,0.827,3.267,1.116,4.976,1.394 c2.684,0.436,34.734,4.478,35.237,2.894c0.001-0.004,4.428-13.968,4.428-13.968 C160.116,417.329,150.128,416.727,144.017,412.596z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M151.046,387.107c0.255-0.015,0.462-0.034,0.613-0.06c4.736-0.813,12.335-2.342,14.534-7.332 c2.253-5.112-1.75-14.388-2.411-19.701c-1.004-8.076-1.338-16.221-1.727-24.344c-0.351-7.323,2.266-14.54,6.097-20.792 c3.831-6.251,8.842-11.678,13.778-17.1c2.053-2.255,4.177-4.667,4.804-7.651c0.694-3.3-0.626-6.785-2.803-9.361 c-3.35-3.964-7.325-5.937-12.384-6.057c-17.757-0.424-31.105,10.08-36.143,27.421c-7.218,24.85,1.799,48.561,0.456,73.288 c-0.229,4.222-1.625,8.375-3.993,11.878C132.497,386.366,147.216,387.326,151.046,387.107z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBCEB1"
    },
    points: "892.063,267.841 890.124,253.449 896.239,252.352 899.749,261.914 902.4,260.053  902.559,272.571 896.356,274.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DB5DB"
    },
    points: "983.351,343.685 928.591,328.668 903.926,268.314 891.821,272.908 905.149,350.618  968.018,384.053  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305399"
    },
    points: "972.906,490.138 972.906,509.439 947.173,593.072 953.606,679.923 937.523,683.139  911.789,576.989 912.774,545.758 924.656,482.063  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305399"
    },
    points: "952.493,512.99 978.35,689.908 990.103,689.908 997.526,593.407 1013.61,496.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "940.185,685.345 927.908,698.339 931.454,704.926 956.788,692.766 952.122,683.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "978.568,694.033 963.433,703.547 965.222,710.811 992.79,705.366 990.677,694.879  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M937.444,296.718c10.424,0.767,20.171-7.793,30.43-5.669 c6.671,1.382,11.937,7.298,13.973,13.966c0.949,3.108,1.285,6.496,0.357,9.586c-0.603,2.006-1.714,3.813-3.023,5.42 c-1.75,2.147-3.889,3.932-6.264,5.302c1.305,2.103,2.799,4.087,4.462,5.921c-4.807,1.841-9.615,3.682-14.422,5.523 c-1.062-2.762-2.125-5.525-3.187-8.287c-1.446-0.08-2.886-0.286-4.298-0.652c-8.536-2.215-15.612-9.69-17.515-18.503 C937.064,305.198,937.236,300.928,937.444,296.718z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E4E4E"
    },
    points: "940.076,299.863 972.307,296.033 978.563,320.654 987.665,313.431 982.975,273.145  937.487,272.165 917.791,283.719 918.625,295.298 936.236,307.153  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DB5DB"
    },
    d: "M952.587,340.58l38.284-15.187c0,0,17.884,37.792,33.351,91.927 c15.467,54.135-4.995,129.314-4.995,129.314s-106.755-21.793-124.269-25.231l34.551-108.27L952.587,340.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M958,224.995l-11.748-14.283l-0.399-0.047c-0.567-1.653-1.134-3.306-1.701-4.958 c-2.993-8.724-5.986-17.449-8.979-26.173c-2.633-7.674-4.278-20.45-14.055-21.673l-92.926-11.625 c-10.321-1.291-20.502,3.788-26.156,13.048l-19.686,32.244l-1.549-0.181l-32.358,5.912 c-11.594,3.978-19.91,14.211-21.431,26.374l-2.286,18.276l235.939,29.515l3.253-26.001 C964.835,238.09,962.695,230.703,958,224.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E8F4"
    },
    d: "M869.166,198.401l61.998,7.756l-9.742-36.441c-0.485-1.814-1.957-3.136-3.741-3.359 l-43.82-5.482L869.166,198.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E8F4"
    },
    d: "M863.255,159.548l-35.514-4.443c-7.526-0.941-14.95,2.762-19.072,9.514L793.8,188.973 l64.761,8.101L863.255,159.548z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFF1"
    },
    d: "M922.075,178.319c0.769,0.544,1.537,1.09,2.306,1.635l-2.666-9.971 c-0.485-1.814-1.957-3.136-3.741-3.359l-15.18-1.899C909.192,169.297,915.655,173.779,922.075,178.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFF1"
    },
    d: "M922.242,186.745c-10.609-7.582-21.704-16.066-32.171-23.842l-14.27-1.554 c8.714,9.593,20.116,18.575,30.174,26.638c6.046,4.846,12.257,9.489,18.67,13.84c2.102,1.426,4.322,2.758,6.547,4.102 l-4.217-15.775C925.401,189.011,923.823,187.875,922.242,186.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFF1"
    },
    d: "M849.27,180.605c-4.399-3.693-9.001-7.166-13.647-10.54c-4.705-3.417-9.478-6.854-14.486-9.819 c-1.651-0.977-3.328-1.904-4.999-2.838c-2.978,1.66-5.575,4.109-7.469,7.212l-0.144,0.237 c4.89,4.415,9.822,8.786,14.672,13.227c7.174,6.568,15.333,11.882,23.266,17.478l12.099,1.514l0.851-6.8 C856.034,187.046,852.851,183.611,849.27,180.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M814.045,253.083c0.34-1.033,0.584-2.107,0.722-3.217c1.366-10.92-7.967-21.079-20.847-22.69 c-5.029-0.629-9.852,0.143-13.948,1.962c7.733,2.665,14.235,7.509,19.295,13.424c2.578,3.013,4.488,6.129,5.859,9.348 L814.045,253.083z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M936.218,268.366c0.335-1.034,0.576-2.108,0.715-3.217c1.366-10.92-7.72-21.048-20.295-22.621 c-4.91-0.614-9.623,0.172-13.629,2.002c7.545,2.641,13.882,7.465,18.807,13.363c2.509,3.004,4.366,6.114,5.695,9.327 L936.218,268.366z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7894 -0.6139 0.6139 0.7894 13.8107 534.8888)",
    style: {
      fill: "#35383F"
    },
    cx: 786.502,
    cy: 247.315,
    rx: 20.904,
    ry: 20.904
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F7"
    },
    d: "M780.874,257.761c-5.769-3.108-7.926-10.304-4.817-16.073 c3.108-5.769,10.304-7.926,16.073-4.817c5.769,3.108,7.925,10.304,4.818,16.073 C793.839,258.712,786.643,260.869,780.874,257.761z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M787.543,255.775c2.27,0.11,4.636-0.4,6.427-1.799c-0.955,1.969-2.924,3.41-5.089,3.724 c-0.735,0.107-1.483,0.091-2.225,0.048c-0.786-0.045-1.574-0.121-2.333-0.329c-2.044-0.56-3.788-2.121-4.571-4.09 c0.257,0.639,2.513,1.348,3.073,1.524C784.356,255.332,785.935,255.697,787.543,255.775z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7894 -0.6139 0.6139 0.7894 30.2098 613.357)",
    style: {
      fill: "#35383F"
    },
    cx: 909.068,
    cy: 262.648,
    rx: 20.904,
    ry: 20.904
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F7"
    },
    d: "M903.44,273.093c-5.769-3.108-7.925-10.304-4.818-16.073 c3.108-5.769,10.304-7.926,16.073-4.818c5.769,3.108,7.926,10.304,4.818,16.073 C916.405,274.044,909.209,276.201,903.44,273.093z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M910.109,271.108c2.27,0.11,4.636-0.399,6.427-1.799c-0.955,1.969-2.924,3.41-5.089,3.724 c-0.735,0.107-1.483,0.091-2.225,0.048c-0.786-0.045-1.574-0.121-2.333-0.329c-2.044-0.56-3.789-2.121-4.571-4.09 c0.257,0.639,2.513,1.348,3.073,1.524C906.922,270.665,908.502,271.03,910.109,271.108z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M849.189,211.597l-7.006-0.876c-1.179-0.147-2.016-1.223-1.868-2.402l0.072-0.577 c0.147-1.179,1.223-2.016,2.402-1.868l7.007,0.876c1.179,0.148,2.016,1.223,1.868,2.402l-0.072,0.577 C851.444,210.908,850.369,211.745,849.189,211.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBCEB1"
    },
    points: "880.784,275.16 879.821,260.67 885.996,259.988 888.853,269.765 891.624,268.087  890.938,280.587 884.614,282.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DB5DB"
    },
    points: "966.753,356.985 913.13,338.311 892.589,276.432 880.202,280.2 888.261,358.632  948.733,396.228  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M833.67,422.759c2.373-0.161,4.61,1.413,5.839,3.45c1.229,2.036,1.617,4.464,1.803,6.836 c0.225,2.86,0.191,5.741-0.099,8.596c-0.167,1.64-0.433,3.315-1.244,4.75c-0.811,1.436-2.272,2.603-3.92,2.646 c-1.13,0.029-2.202-0.456-3.228-0.931c-0.727-0.337-1.495-0.708-1.916-1.39c-0.354-0.572-0.406-1.274-0.449-1.945 C830.162,440.162,826.15,423.27,833.67,422.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M838.607,428.128c-0.139-0.274-0.297-0.539-0.478-0.793c-0.565-0.793-1.572-1.865-2.506-2.218 c0.001,0-3.132-0.694-2.335,0.138l1.652,1.724l-7.038-0.123l-4.463,3.566l0.408,7.591l5.154,5.926 c4.222-0.679,8.929-0.436,10.274-5.433c0.399-1.482,0.367-3.042,0.333-4.576C839.564,431.954,839.484,429.863,838.607,428.128z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M781.064,342.555c4.534-0.197,9.067-0.394,13.601-0.591c0.244-3.61,0.2-7.24-0.134-10.843 c0.04,0.437,7.295-3.387,7.938-4.255c1.848-2.498,2.063-6.693,2.831-9.665c1.638-6.33,3.176-13.458-0.169-19.076 c-3.464-5.818-10.96-7.81-17.729-7.986c-8.499-0.222-17.989,2.255-22.359,9.548c-3.947,6.587,1.033,16.301,2.455,23.267 c0.701,3.434,1.771,7.353,4.962,8.804c1.694,0.77,3.749,0.686,5.262,1.771C780.39,335.441,779.789,339.531,781.064,342.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M751.652,287.094c-0.505-4.698-1.011-9.396-1.516-14.093c-0.188-1.745-0.369-3.555,0.195-5.217 c0.938-2.763,3.744-4.49,6.562-5.252c2.817-0.763,5.783-0.791,8.633-1.419c3.042-0.67,5.999-2.025,9.111-1.888 c5.918,0.261,10.448,5.75,16.297,6.684c8.099,1.294,15.536-2.416,20.426,7.115c0.898,1.751,1.147,3.767,1.94,5.569 c1.023,2.327,2.886,4.163,4.342,6.247c6.404,9.164,4.333,23.071-3.429,30.837c-3.763,3.766-5.302,7.171-10.487,8.379 c2.375-4.827-0.761-24.053-7.262-26.21c-1.722-0.571-6.893,1.536-8.8,1.814c-4.225,0.617-8.331,1.295-12.306,2.941 c-5.899,2.443-12.302,4.174-18.685,4.651c-0.817,0.061-1.729,0.091-2.346-0.447c-0.58-0.507-0.7-1.349-0.783-2.115 C752.914,298.825,752.283,292.96,751.652,287.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M748.231,359.145c0,0-41.532,52.989-62.298,65.878l0.002,0.021 c-1.276,0.245-2.435,1.107-3.191,2.191c-0.943,1.352-1.367,2.994-1.688,4.611c-0.56,2.814-0.866,5.679-0.913,8.548 c-0.039,2.378,0.117,4.832,1.147,6.976c1.03,2.144,3.108,3.923,5.486,3.987c3.199,0.087,4.605-2.967,5.179-6.858 c11.06-7.557,41.055-28.312,43.388-32.702c2.864-5.391,17.902-52.652,17.902-52.652H748.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "853.104,689.133 854.927,696.791 841.433,708.096 831.951,702.26 837.787,692.779  851.281,681.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "822.133,452.218 827.67,475.478 820.65,583.651 853.318,686.474 838.85,693.128  773.393,574.419 765.62,536.498 761.667,456.327  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "731.462,461.441 730.3,561.926 749.236,691.487 763.796,691.487 772.992,571.94  792.917,452.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "763.712,689.754 763.712,697.627 747.967,705.499 740.094,697.627 747.967,689.754  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M839.453,480.661c0.201,9.168-0.088,21.523-3.609,21.975c-0.66,0.085-1.293-0.241-1.87-0.556 c-6.09-3.325-10.399-8.005-16.403-11.218c-6.292-3.367-13.491-5.156-20.55-6.409c-10.556-1.929-21.345-3.125-32.1-3.313 c-8.455-0.147-16.95,0.573-25.369,1.273c-7.005,0.583-13.522,2.659-20.658,2.164c-7.314-0.507-14.518-2.747-20.77-6.59 c-0.229-0.141-0.471-0.301-0.566-0.552c-0.104-0.275-0.003-0.58,0.098-0.857c1.493-4.094,2.567-8.147,5.28-11.538 c3.029-3.786,5.182-8.596,7.372-12.905c4.564-8.981,8.861-18.393,12.051-27.961c4.82-13.005,10.326-25.673,14.985-38.721 c3.229-9.044,6.175-18.249,10.557-26.823c3.431-6.714,9.546-16.521,16.912-19.477c2.493-1,5.244-1.091,7.929-1.168 c8.146-0.234,16.292-0.468,24.438-0.702c2.97-0.085,6.058-0.148,8.766,1.076c4.057,1.834,6.35,6.094,8.355,10.069 c8.989,17.823,14.72,37.04,17.931,56.857c1.676,10.347,3.227,20.715,4.433,31.122c1.347,11.613,2.271,23.279,2.466,34.963 C839.152,472.669,839.358,476.305,839.453,480.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M785.101,382.348c-0.307,4.616,0.352,9.235,1.008,13.816c3.999,27.9,7.998,55.799,11.997,83.699 c-21.873-0.19-43.745-0.381-65.618-0.571c0.792-10.453,1.584-20.907,2.376-31.36c0.508-6.701,1.019-13.426,2.433-20.003 c2.282-10.608,6.86-20.592,11.406-30.482c8.399-18.274,16.799-36.548,25.198-54.822c0.449-0.977,0.922-1.987,1.75-2.69 c0.991-0.842,2.345-1.125,3.639-1.35c6.253-1.086,13.313-2.005,19.596-1.083c1.571,5.72-4.224,15.664-6.372,20.985 C789.391,366.23,785.661,373.916,785.101,382.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M823.253,520.615H703.658c-7.854,0-14.221-6.367-14.221-14.221v-80.599 c0-7.854,6.367-14.221,14.221-14.221h119.594c7.854,0,14.221,6.367,14.221,14.221v80.599 C837.474,514.247,831.107,520.615,823.253,520.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305399"
    },
    d: "M795.873,405.645c0-6.97,0-13.939,0-20.909c0-1.889-1.829-3.495-3.992-3.495 c-16.812,0-33.624,0-50.435,0c-2.405,0-4.81,0-7.214,0c-2.158,0-3.992,1.601-3.992,3.495c0,6.953,0,13.906,0,20.858 c-3.226,0.092-5.815,2.73-5.815,5.979l0,0h19.558l0,0c0-3.23-2.56-5.855-5.76-5.976c0-5.789,0-11.578,0-17.366 c15.482,0,30.963,0,46.444,0c1.074,0,2.149,0,3.223,0c0,5.785,0,11.57,0,17.355h-0.399c-3.307,0-5.987,2.681-5.987,5.987l0,0 h19.558l0,0C801.062,408.538,798.801,406.036,795.873,405.645z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.12
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M824.87,499.069c-5.013,3.783-10.763,6.443-16.829,8.034c-8.458,2.217-17.101,3.674-25.79,4.619 c-30.879,3.36-61.871,0.113-92.815-0.793l-0.281-1.409c0,5.397,4.657,11.182,10.054,11.182h124.181 c7.778,0,14.083-6.305,14.083-14.083v-20.847C833.908,490.758,829.82,495.333,824.87,499.069z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M797.765,455.133c-8.016,0-16.031,0-24.046,0c-0.751,0-1.502,0-2.252,0 c0-5.837,0-11.675,0-17.512c0-2.929,0-5.858,0-8.786c0-0.976-0.827-1.805-1.805-1.805c-4.982,0-9.963,0-14.945,0 c-0.976,0-1.805,0.827-1.805,1.805c0,8.015,0,16.031,0,24.046c0,0.751,0,1.501,0,2.252c-5.837,0-11.675,0-17.512,0 c-2.929,0-5.858,0-8.786,0c-0.976,0-1.805,0.827-1.805,1.805c0,4.982,0,9.963,0,14.945c0,0.553,0.206,0.974,0.518,1.264 c0.29,0.325,0.719,0.542,1.287,0.542c8.016,0,16.031,0,24.046,0c0.751,0,1.502,0,2.252,0c0,5.837,0,11.675,0,17.512 c0,2.929,0,5.858,0,8.786c0,0.976,0.827,1.805,1.805,1.805c4.982,0,9.963,0,14.945,0c0.553,0,0.974-0.206,1.264-0.518 c0.326-0.29,0.542-0.719,0.542-1.287c0-8.015,0-16.031,0-24.046c0-0.751,0-1.502,0-2.252c5.837,0,11.675,0,17.512,0 c2.929,0,5.858,0,8.786,0c0.976,0,1.805-0.827,1.805-1.805c0-4.982,0-9.963,0-14.945 C799.571,455.962,798.744,455.133,797.765,455.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M682.37,445.186c0.112,0.286,0.244,0.565,0.401,0.835c0.487,0.843,1.388,2.006,2.284,2.446 c-0.001-0.001,3.052,0.987,2.338,0.084l-1.481-1.872l6.994,0.789l4.781-3.128l0.313-7.595l-4.569-6.388 c-4.268,0.275-8.93-0.413-10.743,4.435c-0.538,1.438-0.654,2.993-0.765,4.524C681.779,441.287,681.661,443.377,682.37,445.186z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAC5B0"
    },
    points: "715.446,367.415 726.429,359.913 723.428,355.08 714.769,358.551 714.411,355.606  705.795,363.17 708.237,368.616  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M707.854,359.631c0,0,4.293,11.054,4.293,11.055c0.588,1.814-41.014,25.297-44.718,26.982 c-8.156,3.712-22.945,12.47-22.945,12.47c-11.342,0.142-32.702-5.667-39.835-8.736c-2.874-1.237-4.922-7.6-6.665-10.132 c-2.211-3.21,0.604-8.867,2.5-11.485c3.888-5.369,9.855-9.191,16.358-10.477c2.336-0.462,4.784-0.603,7.078,0.036 c2.364,0.658,5.388-10.231,7.394-8.817c3.563,2.512,5.538,19.088,9.781,20.532C646.421,382.873,706.595,357.029,707.854,359.631 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M622.292,308.952c-0.246,0.008-0.491,0.018-0.734,0.03c-11.67,0.568-25.802,15.888-33.989,24.931 c-21.132,23.341-35.892,50.088-46.938,79.993c-5.948,16.102-11.2,32.467-16.123,48.924c-1.36,4.547-10.912,46.127-13.228,46.423 c23.754-3.034,47.669-5.406,71.328-3.764s47.188,7.443,67.473,19.921c10.386-53.362,18.064-108.621,20.58-162.694 c0.301-6.467,1.287-13.139,0.678-19.567c-0.701-7.403-4.35-10.738-8.491-16.359c-1.419-1.926-2.848-3.864-4.583-5.456 C649.12,312.941,634.518,308.554,622.292,308.952z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBCEB1"
    },
    points: "539.416,490.232 564.136,590.564 564.688,664.518 576.691,667.113 581.381,598.334  593.164,472.376  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "576.843,669.186 578.782,676.688 577.08,691.404 567.354,691.421 563.711,670.148  564.84,666.591  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBCEB1"
    },
    points: "633.798,479.15 635.979,565.846 624.406,688.292 612.557,689.159 608.3,576.906  584.17,475.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B455A"
    },
    points: "624.036,686.246 639.996,694.72 638.729,702.175 610.535,698.721 611.89,687.993  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DB5DB"
    },
    points: "637.271,490.336 645.302,590.5 637.132,659.194 605.036,657.375 599.316,579.277  585.436,494.133 587.592,480.876 633.849,481.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DB5DB"
    },
    points: "588.612,583.212 584.841,655.057 556.942,653.627 557.511,585.49 539.919,499.923  543.933,476.004 590.853,478.925  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M643.094,498.602c-28.626-4.938-75.009-16.9-103.635-21.838 c14.981-49.737,38.824-104.988,66.623-148.676c5.042-7.924,11.342-16.192,20.365-18.072c9.668-2.014,26.616,4.358,28.494,15.171 c2.747,15.819-2.955,37.637-4.714,53.633C646.245,415.012,650.015,462.845,643.094,498.602z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC5B0"
    },
    d: "M638.122,275.112c10.765-18.735,34.617-6.566,36.163,12.171 c1.018,12.342-10.981,25.933-23.384,26.891c-0.252,2.968-0.63,5.925-1.135,8.861c-3.136-0.856-6.271-1.712-9.406-2.567 c-0.97-0.265-2.082-0.658-2.397-1.613c-0.19-0.579-0.022-1.207,0.146-1.793c0.567-1.974,1.134-3.948,1.7-5.922 c-0.211-0.147-0.42-0.298-0.628-0.457c-5.163-3.938-7.51-10.799-7.212-17.286C632.266,286.911,634.887,280.742,638.122,275.112z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M638.812,281.452c-5.2,4.989-5.681,12.975-6.024,19.836c-0.304,6.084-1.209,9.718-7.666,8.003 c-3.638-0.966-10.13-2.613-11.669-6.599c-1.164-3.019,3.11-8.197,5.375-9.955c1.73-1.342,4.323-1.122,6.016-2.51 c0.698-0.572,1.174-1.366,1.605-2.159c1.762-3.238,3.032-6.744,3.751-10.359c0.489-2.455,0.734-4.99,1.706-7.297 c1.409-3.345,5.636-5.883,8.373-8.197c5.092-4.305,16.656-7.589,20.843,0.1c0.953,1.751,0.938,3.854,0.803,5.843 c-0.08,1.188-0.204,2.406-0.746,3.466c-2.162,4.226-6.37,2.916-10.07,3.52C646.545,275.889,642.13,278.268,638.812,281.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M668.784,298.491c-1.326,3.1-4.626,5.585-4.307,8.941c0.142,1.495,1.013,2.805,1.604,4.185 c1.616,3.771,1.051,8.389-1.426,11.66c6.076,2.906,12.151,5.811,18.227,8.717c0.916,0.438,1.883,0.887,2.897,0.826 c2.167-0.13,3.469-2.393,4.371-4.367c1.778-3.887,3.6-8.092,2.807-12.292c-0.367-1.947-1.284-3.759-1.645-5.707 c-1.737-9.372,9.495-18.308,6.055-27.197c-1.535-3.966-5.553-6.316-8.273-9.586c-4.742-5.702-5.417-14.083-10.519-19.466 c-9.635-10.165-28.536-1.842-27.086,12.275C652.672,277.991,674.122,286.007,668.784,298.491z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587BC9"
    },
    d: "M620.739,311.901c0,0-49.506,119.387-38.573,149.84c10.934,30.453,16.02,42.25,16.02,42.25 l-75.806,3.168C522.38,507.158,570.766,332.745,620.739,311.901z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 442.112,
    y: 170.975,
    style: {
      fill: "#3B455A"
    },
    width: 204.796,
    height: 273.294
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.26
    },
    points: "457.391,432.528 460.456,432.528 641.31,438.138 636.579,179.679 628.173,182.097  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.44,
    y: 179.679,
    style: {
      fill: "#FFFFFF"
    },
    width: 184.139,
    height: 252.849
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBEC0"
    },
    d: "M568.104,155.635h-1.241v-0.837c0-7.882-7.339-14.271-16.392-14.271h-11.924 c-9.053,0-16.392,6.389-16.392,14.271v0.837h-1.241c-9.053,0-16.392,6.389-16.392,14.271v15.944h79.972v-15.944 C584.496,162.024,577.157,155.635,568.104,155.635z M555.045,155.963h-21.07c-2.154,0-3.916-1.762-3.916-3.916 c0-2.154,1.762-3.916,3.916-3.916h21.07c2.154,0,3.916,1.762,3.916,3.916C558.961,154.201,557.198,155.963,555.045,155.963z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 504.524,
    y: 178.343,
    style: {
      fill: "#BCBEC0"
    },
    width: 79.972,
    height: 7.507
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 476.44,
    y: 272.085,
    style: {
      fill: "#BCBEC0"
    },
    width: 138.378,
    height: 3.722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.44,
    y: 299.527,
    style: {
      fill: "#BCBEC0"
    },
    width: 138.378,
    height: 3.722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.44,
    y: 326.969,
    style: {
      fill: "#BCBEC0"
    },
    width: 138.378,
    height: 3.722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.44,
    y: 354.411,
    style: {
      fill: "#BCBEC0"
    },
    width: 138.378,
    height: 3.722
  })), /*#__PURE__*/React.createElement("rect", {
    x: 476.318,
    y: 410.059,
    style: {
      fill: "#BCBEC0"
    },
    width: 50.867,
    height: 1.314
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBEC0"
    },
    d: "M598.7,386.704c-2.458-0.917-5.182-0.684-7.452,0.48c-0.34-0.178-0.691-0.343-1.059-0.48 c-3.677-1.371-7.949-0.175-10.406,2.872c-2.401,2.977-2.72,7.244-0.767,10.539c1.982,3.345,5.91,5.072,9.716,4.372 c0.906-0.167,1.755-0.469,2.533-0.879c1.808,0.922,3.91,1.259,5.978,0.879c4.374-0.804,7.426-4.725,7.515-9.093 C604.68,391.534,602.35,388.065,598.7,386.704z M589.632,402.691c-3.031,1.091-6.497,0.17-8.579-2.289 c-2.114-2.496-2.409-6.163-0.74-8.971c1.661-2.795,4.994-4.29,8.187-3.651c0.433,0.087,0.85,0.21,1.249,0.363 c-0.532,0.418-1.022,0.896-1.455,1.433c-2.401,2.977-2.72,7.244-0.767,10.539c0.588,0.992,1.349,1.841,2.225,2.527 C589.711,402.658,589.673,402.676,589.632,402.691z M594.744,395.394c-0.053,2.626-1.356,5.064-3.494,6.484 c-0.623-0.403-1.194-0.895-1.686-1.476c-2.114-2.496-2.409-6.163-0.74-8.971c0.611-1.027,1.448-1.877,2.421-2.512 C593.356,390.33,594.691,392.745,594.744,395.394z M598.143,402.691c-1.773,0.638-3.692,0.583-5.399-0.06 c2.125-1.728,3.445-4.387,3.502-7.237c-0.058-2.86-1.355-5.504-3.507-7.236c1.339-0.514,2.819-0.669,4.271-0.378 c3.643,0.729,6.17,3.947,6.244,7.614C603.19,398.629,601.229,401.58,598.143,402.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M477.685,207.872h2.259v18.744h-2.259V207.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M496.788,207.872h2.259v18.744h-2.465l-8.935-14.944v14.944h-2.259v-18.744h2.465l8.935,14.97 V207.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M514.568,218.322c0.745,0.736,1.117,1.871,1.117,3.402c0,1.532-0.535,2.79-1.605,3.775 c-1.07,0.985-2.619,1.476-4.647,1.476c-2.028,0-3.514-0.419-4.455-1.258c-0.942-0.838-1.532-2.045-1.772-3.62l1.849-0.334 c0.325,2.26,1.72,3.39,4.185,3.39c2.79,0,4.185-1.104,4.185-3.312c0-0.959-0.257-1.669-0.77-2.131 c-0.513-0.462-1.369-0.856-2.567-1.181l-1.695-0.488c-1.763-0.479-3.004-1.091-3.723-1.836 c-0.719-0.745-1.078-1.882-1.078-3.415c0-1.532,0.514-2.794,1.541-3.787c1.027-0.992,2.52-1.49,4.48-1.49 c1.96,0,3.385,0.42,4.275,1.258c0.89,0.839,1.455,2.046,1.695,3.621l-1.848,0.333c-0.326-2.259-1.627-3.389-3.903-3.389 c-2.654,0-3.98,1.104-3.98,3.313c0,0.959,0.235,1.674,0.706,2.144c0.471,0.471,1.271,0.86,2.401,1.168l1.772,0.488 C512.543,216.961,513.823,217.587,514.568,218.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M530.423,207.872h2.259v12.556c0,1.147-0.137,2.132-0.411,2.953 c-0.274,0.822-0.612,1.46-1.014,1.913c-0.403,0.454-0.92,0.813-1.554,1.078c-0.633,0.265-1.219,0.432-1.759,0.501 c-0.539,0.068-1.169,0.103-1.887,0.103c-0.719,0-1.348-0.034-1.887-0.103c-0.539-0.069-1.121-0.236-1.746-0.501 c-0.625-0.265-1.139-0.625-1.541-1.078c-0.402-0.453-0.74-1.091-1.014-1.913c-0.274-0.822-0.411-1.806-0.411-2.953v-12.556 h2.259v12.479c0,1.986,0.471,3.303,1.412,3.954c0.462,0.308,0.915,0.514,1.361,0.617c0.445,0.103,0.971,0.154,1.579,0.154 c0.607,0,1.134-0.051,1.579-0.154c0.445-0.103,0.898-0.308,1.361-0.617c0.941-0.633,1.412-1.951,1.412-3.954V207.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M537.74,207.872h5.674c1.113,0,2.067,0.163,2.863,0.488c0.796,0.325,1.391,0.77,1.785,1.335 c0.736,1.062,1.104,2.294,1.104,3.698c0,2.687-1.079,4.399-3.235,5.135c0.462,0.343,0.873,0.908,1.232,1.694l2.773,6.394 h-2.414l-2.593-6.085c-0.274-0.616-0.616-1.036-1.027-1.258c-0.411-0.223-0.984-0.351-1.72-0.385h-2.182v7.729h-2.259V207.872z  M539.999,217.09h3.312c1.249,0,2.161-0.355,2.735-1.066c0.573-0.71,0.86-1.592,0.86-2.645c0-1.053-0.287-1.934-0.86-2.645 c-0.574-0.71-1.485-1.065-2.735-1.065h-3.312V217.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M557.998,207.872h3.004l6.137,18.744h-2.234l-1.823-5.649h-7.138l-1.823,5.649h-2.234 L557.998,207.872z M559.513,209.875l-3.004,9.295h5.982L559.513,209.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M581.697,207.872h2.259v18.744h-2.464l-8.935-14.944v14.944h-2.259v-18.744h2.465l8.935,14.97 V207.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M595.792,209.361c-1.592,0-2.782,0.446-3.569,1.335c-0.702,0.771-1.13,2.038-1.284,3.8 c-0.069,0.736-0.103,1.643-0.103,2.722c0,1.079,0.034,1.999,0.103,2.761c0.068,0.762,0.209,1.484,0.424,2.169 c0.214,0.685,0.501,1.233,0.86,1.643c0.787,0.89,1.977,1.335,3.569,1.335c2.636,0,3.997-1.403,4.082-4.21l1.849,0.103 c-0.12,1.9-0.638,3.368-1.553,4.403c-0.916,1.036-2.375,1.553-4.378,1.553c-2.824,0-4.75-0.873-5.777-2.619 c-0.531-0.874-0.903-1.874-1.117-3.004c-0.214-1.13-0.321-2.503-0.321-4.121c0-1.617,0.107-2.992,0.321-4.121 c0.214-1.13,0.586-2.131,1.117-3.004c1.027-1.729,2.953-2.594,5.777-2.594c1.866,0,3.252,0.424,4.16,1.271 c0.907,0.847,1.464,2.058,1.669,3.633l-1.823,0.334C599.439,210.491,598.103,209.361,595.792,209.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M605.78,207.872h9.962v1.798h-7.703v6.521h7.164v1.797h-7.164v6.83h8.216v1.797H605.78V207.872z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M516.058,250.469h-3.261v6.958h-2.259v-18.744h5.521c3.868,0,5.803,1.964,5.803,5.893 S519.926,250.469,516.058,250.469z M512.797,248.671h3.133c2.448,0,3.672-1.364,3.672-4.095c0-2.73-1.224-4.095-3.672-4.095 h-3.133V248.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M538.113,254.936c-0.531,0.924-1.292,1.631-2.285,2.119c-0.993,0.487-2.212,0.732-3.659,0.732 c-1.447,0-2.662-0.24-3.646-0.719c-0.985-0.479-1.737-1.185-2.259-2.118c-0.522-0.933-0.89-1.947-1.104-3.043 c-0.214-1.095-0.321-2.298-0.321-3.608c0-1.31,0.06-2.422,0.18-3.338c0.12-0.915,0.347-1.801,0.68-2.658 c0.334-0.855,0.766-1.566,1.297-2.131c1.181-1.233,2.91-1.849,5.187-1.849c2.875,0,4.853,0.959,5.931,2.876 c0.531,0.924,0.903,1.934,1.117,3.029c0.214,1.096,0.321,2.376,0.321,3.839c0,1.463-0.107,2.743-0.321,3.838 C539.016,253.003,538.643,254.012,538.113,254.936z M532.336,255.938c0.89,0,1.682-0.201,2.375-0.603 c0.693-0.402,1.22-0.976,1.579-1.721c0.359-0.744,0.616-1.566,0.77-2.464c0.154-0.899,0.231-1.93,0.231-3.094 c0-1.164-0.077-2.195-0.231-3.094c-0.154-0.899-0.411-1.725-0.77-2.478c-0.753-1.541-2.123-2.311-4.108-2.311 c-1.592,0-2.791,0.505-3.595,1.515c-0.993,1.249-1.49,3.372-1.49,6.368c0,2.996,0.497,5.119,1.49,6.368 C529.391,255.433,530.641,255.938,532.336,255.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M544.172,257.427v-18.744h2.259v16.947h6.984v1.797H544.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M556.548,238.683h2.259v18.744h-2.259V238.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M570.643,240.173c-1.592,0-2.782,0.445-3.569,1.335c-0.702,0.771-1.13,2.038-1.284,3.8 c-0.068,0.736-0.103,1.643-0.103,2.722c0,1.079,0.034,1.999,0.103,2.761c0.068,0.762,0.209,1.485,0.424,2.169 c0.214,0.685,0.501,1.233,0.86,1.643c0.787,0.89,1.977,1.335,3.569,1.335c2.636,0,3.997-1.403,4.083-4.21l1.849,0.103 c-0.12,1.9-0.638,3.368-1.553,4.403c-0.916,1.035-2.375,1.553-4.378,1.553c-2.824,0-4.75-0.873-5.777-2.619 c-0.531-0.873-0.903-1.874-1.117-3.004c-0.214-1.13-0.321-2.503-0.321-4.121c0-1.617,0.107-2.992,0.321-4.121 c0.214-1.13,0.586-2.132,1.117-3.004c1.027-1.729,2.953-2.594,5.777-2.594c1.866,0,3.252,0.424,4.16,1.271 c0.907,0.847,1.464,2.058,1.669,3.633l-1.823,0.334C574.289,241.302,572.954,240.173,570.643,240.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B455A"
    },
    d: "M586.1,257.427h-2.26v-6.522l-5.777-12.222h2.311l4.596,10.014l4.596-10.014h2.311 l-5.777,12.222V257.427z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/Hero.567957068d79b73bbcf3de9fc552ab61.svg";
export { ForwardRef as ReactComponent };